import { type PropType, defineComponent } from 'vue'
export interface IRecord {
  id: string
}
export default defineComponent({
  props: {
    record: {
      type: Object as PropType<IRecord>,
      default: null
    },
    text: {
      type: Number as PropType<number>,
      default: 0
    }
  }
})
